export default __webpack_public_path__ + "static/media/DSC03438.0b910f59.JPG";